import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Firebase Web Config (read from Vite environment variables)
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

let app: any;
let messaging: any;

try {
  // Only initialize if config is present
  if (firebaseConfig.apiKey && firebaseConfig.projectId) {
    app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);
  }
} catch {
  // Silence initialization errors
}

/**
 * Requests browser permission for notifications and retrieves the FCM token.
 */
export async function requestNotificationPermissionAndGetToken(): Promise<string | null> {
  if (!messaging) {
    return null;
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
      });
      return token;
    } else {
      return null;
    }
  } catch {
    return null;
  }
}

/**
 * Registers a callback to handle messages when the app is in the foreground.
 */
export function onForegroundMessage(callback: (payload: any) => void) {
  if (!messaging) {
    return () => {};
  }
  return onMessage(messaging, callback);
}
